(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/shared/constants.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/shared/constants.js');

'use strict';

const CONSTANTS = {
  CHARITY_STATUS: {
    ACTIVE: 1,
    INACTIVE: 2,
    HIDDEN: 4
  }
};
setGlobal('svs.tur.lyckoplatsen.shared', {
  CONSTANTS
});

 })(window);